export function initSplitRUMAgent(key) {
  if (window.SPLIT_RUM) {
    window.SPLIT_RUM.init(process.env.GATSBY_SPLIT_IO_SDK_KEY).identities([{ key, trafficType: 'User' }])
  }
}
